import {
  bnb,
  btc,
  doge,
  eth,
  pol,
  growth,
  happiness,
  retention,
  revenue,
  shiba,
  solana,
  survey,
  tether,
  trx,
  usdc,
  website,
} from "../assets/images";

export const assetLogo = [
  {
    id: 1,
    name: "SOL",
    image: solana,
  },
  {
    id: 2,
    name: "USDT",
    image: tether,
  },
  {
    id: 3,
    name: "BTC",
    image: btc,
  },
  {
    id: 4,
    name: "ETH",
    image: eth,
  },
  {
    id: 5,
    name: "SHIB",
    image: shiba,
  },
  {
    id: 6,
    name: "DOGE",
    image: doge,
  },
  {
    id: 7,
    name: "TRX",
    image: trx,
  },
  {
    id: 8,
    name: "USDC",
    image: usdc,
  },
  {
    id: 9,
    name: "BNB",
    image: bnb,
  },
  {
    // Polygon's current ticker. Deliberately not also listed as MATIC: this
    // array is the canonical coin list — it drives the invite-code pair picker
    // and the balance display order — so an alias row would show up as a
    // duplicate, selectable coin. Use getAssetImage() below to resolve a
    // legacy MATIC record to this logo.
    id: 10,
    name: "POL",
    image: pol,
  },
];

/** Codes that mean the same asset as a canonical `assetLogo` entry. */
const ASSET_ALIASES: Record<string, string> = {
  MATIC: "POL",
};

/**
 * Logo for a currency code, tolerant of aliases and casing.
 *
 * Prefer this over `assetLogo.find(...)` at call sites that render whatever
 * currency a record happens to carry — transactions written before Polygon's
 * rename still say MATIC.
 */
export const getAssetImage = (symbol?: string | null) => {
  if (!symbol) return undefined;

  const code = symbol.trim().toUpperCase();
  const canonical = ASSET_ALIASES[code] ?? code;

  return assetLogo.find((asset) => asset.name === canonical)?.image;
};

export const API_URL = process.env.REACT_APP_API_URL;

/**
 * Public hostnames, on the usedeex.com domain.
 *
 * Staging normalised to `<app>.staging.` — the old domain used `staging.admin.`, which was
 * inconsistent with the PWA. See ALLOWLIST-ORIGINS.md; DNS must be created in this shape.
 */
export const PROD_LOGIN_LINK = "https://admin.usedeex.com";
export const STAGING_LOGIN_LINK = "https://admin.staging.usedeex.com";
export const PROD_LINK = `${PROD_LOGIN_LINK}/dashboard`;
export const STAGING_LINK = `${STAGING_LOGIN_LINK}/dashboard`;
/** Customer app base for referral links (?r=) shown in admin */
export const PROD_REFERRAL_BASE = "https://app.usedeex.com/signup";
export const STAGING_REFERRAL_BASE = "https://app.staging.usedeex.com/signup";
export const reports = [
  {
    title: "Revenue",
    image: revenue,
    content:
      "How much does each user generate to/for us per year. How much money did we spend to acquire a user, etc",
  },
  {
    title: "Growth",
    image: growth,
    content:
      "Total users per month or week, there source, if they signed up (activated user), if they buy.",
  },
  {
    title: "Retention",
    image: retention,
    content:
      "Users who came back to login  by theirselves. Resurrected users are users we got back by ourselves.",
  },
  {
    title: "Website",
    image: website,
    content:
      "How much does each user generate to/for us per year. How much money did we spend to acquire a user, etc, ",
  },
  {
    title: "Happiness",
    image: happiness,
    content:
      "App Store rating, NPS scores, customer success rating, customer feedback scores, etc.",
  },
  {
    title: "Survey",
    image: survey,
    content:
      "Collect feedback and data for market research, product development, and more. ",
  },
];

export const options = [
  { value: "frontend_developer", label: "Frontend Developer" },
  { value: "backend_developer", label: "Backend Developer" },
  { value: "fullstack_developer", label: "Fullstack Developer" },
  { value: "product_manager", label: "Product Manager" },
  { value: "project_manager", label: "Project Manager" },
  { value: "graphic_designer", label: "Graphic Designer" },
  { value: "ui_ux_designer", label: "UI/UX Designer" },
  { value: "devops_engineer", label: "DevOps Engineer" },
  { value: "data_scientist", label: "Data Scientist" },
  { value: "qa_engineer", label: "QA Engineer" },
  { value: "qa_tester", label: "QA Tester" },
  { value: "mobile_developer", label: "Mobile Developer" },
  { value: "cloud_engineer", label: "Cloud Engineer" },
  { value: "database_administrator", label: "Database Administrator" },
  { value: "cybersecurity_specialist", label: "Cybersecurity Specialist" },
  { value: "technical_writer", label: "Technical Writer" },
  { value: "machine_learning_engineer", label: "Machine Learning Engineer" },
  { value: "it_support_specialist", label: "IT Support Specialist" },
  { value: "software_architect", label: "Software Architect" },
  { value: "CTO", label: "CTO" },
];

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini (fmr. Swaziland)",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (formerly Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
